export const DEDUCTIONS_GIFT_CARD_TEST_ID = 'totals-deductions-giftcards';
